<template>
  <aside>
    <nav class="menu">
      <a
        v-for="role in roles"
        :key="role.value"
        class="menu__item"
        :class="{ 'menu__item--active': role.value === model }"
        @click="model = role.value"
      >
        {{ role.text }}
      </a>
    </nav>
  </aside>
</template>

<script setup>
defineProps({
  roles: Array,
})

const model = defineModel()
</script>